module.exports = __webpack_public_path__ + "static/media/Watertower_3.e648e1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/watertower/Watertower_3.png
// module id = 1275
// module chunks = 3